import React, { Fragment, useState } from 'react';
import {
  ModalFooter,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Button,
} from 'reactstrap';
import { useDropzone } from 'react-dropzone';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
const UploadAttachments = ({ visible, toggleModal, handleFiles, files }) => {
  const [attachementList, setAttachmentList] = useState(files || []);
  const fileObj = [];
  const { getRootProps, getInputProps } = useDropzone({
    //accept: 'image/*',
    // accept: 'image/*,font/*',
    onDrop: (acceptedFiles) => {
      acceptedFiles.map((file) => {
        if (!file.name.includes('exe')) {
          fileObj.push({
            img: Object.assign(file, {
              preview: URL.createObjectURL(file),
            }),
          });
        }
      });
      setAttachmentList([...attachementList, ...fileObj]);
    },
  });

  const handleRemove = (index) => {
    let lst = [...attachementList];
    lst = lst.filter((f, i) => i !== index);
    setAttachmentList(lst);
    handleFiles(lst);
  };

  const handleSubmit = () => {
    handleFiles(attachementList);
    toggleModal();
  };
  return (
    <Modal
      isOpen={visible}
      toggle={toggleModal}
      wrapClassName="modal-right"
      backdrop="static"
    >
      <ModalHeader toggle={toggleModal}>Attachments</ModalHeader>
      <ModalBody>
        <Row className="mb-4">
          <section className="container">
            <div {...getRootProps({ className: 'dropzone' })}>
              <input {...getInputProps()} />
              <div class="dz-default dz-message">
                <span>Drop files here to upload, or click to select files. Recommended upload limit of 10mb per file. Supported formats: JPEG, PNG, GIF, WEBP, SVG.</span>
                <p className="font-weight-medium mb-0 ">
                  <i className="demo-icon simple-icon-cursor-move"></i>
                </p>
              </div>
            </div>
          </section>
        </Row>{' '}
        {attachementList.map((file, index) => (
          <Row
            className="mb-2 m-2"
            style={{ border: '1px solid', padding: '5px 10px' }}
          >
            {' '}
            <section className="container">
              <Colxx md="10">
                <div className="dz-preview dz-file-preview mb-3" key={index}>
                  <div className="row">
                    <div>
                      <span data-dz-name>{file.img.name}</span>{' '}
                    </div>
                    <div className="text-primary text-extra-small" data-dz-size>
                      {file.img.size}
                    </div>
                  </div>
                </div>
              </Colxx>
              <Colxx md="2">
                <Button
                  color="danger"
                  outline
                  size="xs"
                  onClick={() => handleRemove(index)}
                >
                  X
                </Button>
              </Colxx>
            </section>
          </Row>
        ))}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" size="xs" outline onClick={handleSubmit}>
          Attach
        </Button>
        <Button color="secondary" size="xs" outline onClick={toggleModal}>
          <IntlMessages id='pages.cancel' />
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default UploadAttachments;
